// Libraries
import {
  Injectable,
  Output,
  EventEmitter
} from '@angular/core';
import { HttpParams } from '@angular/common/http';
import * as lodash from 'lodash';

/**
 * `PollingService` service to manage a set of polling components.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@Injectable()
export class PollingService {
  // Public properties
  /**
   * Output emmiter add event.
   */
  @Output() refresh = new EventEmitter<HttpParams>();

  // Private properties
  /**
   * Count of request running.
   */
  private requestRunningCount = 0;
  /**
   * Current params.
   */
  private params: any = {};

  // Public methods
  /**
   * Execute refresh event.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof PollingService
   */
  forceRefresh() {
    this.refresh.next(this.generateParams());
  }

  /**
   * Handles start request loading.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof PollingService
   */
  startLoading() {
    this.requestRunningCount++;
  }

  /**
   * Handles end request loading.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof PollingService
   */
  endLoading() {
    this.requestRunningCount--;
  }

  /**
   * Check if any request is running.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof PollingService
   */
  isUpdating(): boolean {
    return this.requestRunningCount > 0;
  }

  /**
   * Set request params.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof PollingService
   */
  setParam(key: string, value: string) {
    this.params[key] = value;
  }

  // Private methods
  /**
   * Generate request params.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof PollingService
   */
  private generateParams(): HttpParams {
    let params = new HttpParams();
    // Create http params object.
    lodash.forEach(this.params, (value: string, key: string) => {
      // Check param value
      if (!lodash.isNull(value) && !lodash.isUndefined(value)) {
        params = params.set(key, value);
      }
    });
    return params;
  }
}
